module.exports = __webpack_public_path__ + "static/img/ability-pain.7ef2683f.png";